import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import {
  getDataFromAPI,
  getCohortListAPI,
  getCohortsDetailsAPI,
  getCohortSeedDataAPI,
  getDataFromPartnerAPI,
  PostcohortsbasicDataFromPartnerAPI,
} from "../HandleAPICalls/actions";

import { setLoading, saveData, setActivePage } from "./action.js";
import { parseVMCohortTypesOptions } from "../../utils/parseResponseToOptions";
import VMCohortListing from "./component";

let cohortid;
class VMCohortListingContainer extends Component {
  vms;
  constructor() {
    super();
    this.state = {
      loading: true,
      vmCohortList: [],
      vmCohortDetails: null,
      totalPages: 0,
      activePage: 1,
      limit: 50,
      offset: 0,
      vmTypeId: "",
      cohorts_types: [],
      machines: [],
      users: [],
      cohortvalue: [],
      cohortvalue1: [],
      addvm: [],
      addvm1: [],
      users: [],
      filteraddvm: [],
      data: [],
      searchCohortQuery: [],
      cohort_name: "",
      area_name: "",
      cohortTypeId: null,
      description: "",
      lat: "",
      lng: "",
      usersList: [],
      openbasicvmmodal: false,
      modal: false,
      openaddvmmodal: false,
      removevmmodal:false,
      openaddUsersmodal:false,
      AddusersList:[],
      removeusersmodal:false,
      filterType:'NAME',
      searchName:""
    };
  }
  componentDidMount() {
    this.props.getCohortListAPI(
      "/dashboard/api/v2/admin/vendingmachines/vm-cohorts",
      "GET",
      undefined,
      (response) => {
        this.setState({
          vmCohortList: response.list,
          totalPages: response.total_count,
          loading: false,
        });
      },
      (err) => {
        console.log(err);
        toastr.error(
          "Failed",
          "Unable to fetch vending machine cohort listing"
        );
        this.setState({ loading: false });
      }
    );

    this.props.getCohortSeedDataAPI(
      "/dashboard/api/v2/admin/vendingmachines/vm-cohorts/seed",
      "GET",
      (response) => {
        console.log(
          "FETCH ALL COHORTS AND MACHINE AND USERS ##############################################",
          response
        );
        this.setState({
          cohorts_types: parseVMCohortTypesOptions(response.cohort_types),

          machines: response.machines,

          users: response.users,
          /*   users: this.parseStateAndCityOptions(
            this.filterUsers(response.users)
          ), 
          
          
            addvm: this.parseStateAndCityOptions1(
            this.filterAddVm(this.state.addvm1)
          ),
          
          */
        });
      },
      (err) => {
        console.log(err);
        toastr.error(
          "Failed",
          "Unable to fetch vending machine cohort listing"
        );
        this.setState({ loading: false });
      }
    );
  }

  /*   componentDidUpdate=()=>{
console.log("COMPONENTDIDUPDATE");


  }
 */

  removeVmCohorts = (vmId, cohortId) => {
    console.log("REMOVE VM FROM COHORTS  VMID", vmId);
    console.log("REMOVE VM FROM COHORTS Id", cohortId);

    this.props.PostcohortsbasicDataFromPartnerAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/${cohortId}/vendingmachines/${vmId}`,
      "DELETE",

      (response) => {
        console.log("api hit");
        console.log();
      },
      (err) => {
        console.log(err);
      }
    );
  };
  onClickOfDelete = (vmId, cohortId) => {
    if (!confirm(`Are you sure you want to delete "${vmId}"`)) {
      return;
    }
    // this.props.setLoading(true);

    if (!vmId) {
      this.props.setLoading(false);
      return toastr.warning("Invalid", "Invalid User Id");
    }
    this.props.PostcohortsbasicDataFromPartnerAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/${cohortId}/vendingmachines/${vmId}`,
      "DELETE",
      (response) => {
        console.log("true");

        toastr.success("Successful", "Deleted the user");
        this.props.setLoading(false);
        this.loadUserData(cohortId);
      },
      (err) => {
        this.props.setLoading(false);
       /*  toastr.error("Failed", "Delete user operation failed"); */
       toastr.success("Successful", `Deleted VM ${vmId}` );
        this.loadUserData(cohortId);
      }
    );
  };

  loadUserData = (id) => {
    console.log(
      "________________________________________________________________________________________________________________",
      id
    );
    this.props.getCohortsDetailsAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/`,
      "GET",
      id,
      (response) => {
        console.log("LOADUSER-------------", response);
        this.props.saveData(response);
        this.props.setLoading(false);
        console.log("LOADUSER------ done DONE-------", response);
        this.setState({
          vmCohortDetails: response,
        });
      },
      (err) => {
        this.props.setLoading(false);
        toastr.error("ERROR", err);
        console.log(err);
      }
    );
  };

  onChangeOfLng = (event) => {
    this.setState({ lng: event.target.value });
    console.log(this.state.lng);
  };

  onChangeOfLat = (event) => {
    this.setState({ lat: event.target.value });
    console.log(this.state.lat);
  };

  onChangeOfName = (event) => {
    this.setState({ cohort_name: event.target.value });
    console.log(this.state.cohort_name);
  };

  onChangeOfAreaName = (event) => {
    this.setState({ area_name: event.target.value });
    console.log(this.state.area_name);
  };
  parseStateAndCityOptions = (options) => {
    if (!options && options.length) {
      return { key: 0, text: "None", value: 0 };
    }
    const parsed = options.map((el) => ({
      key: el.id,
      text: el.name,
      value: `${el.id}`,
    }));
    return [...parsed];
  };

  parseUsersOptions = (options) => {
    if (!options && options.length) {
      return { key: 0, text: "None", value: 0 };
    }
    const parsed = options.map((el) => ({
      key: el.id,
      text: `${el.name}`+`_id:-`+`${el.id}`,
      value: `${el.id}`,
    }));
    return [...parsed];
  };
  parseStateAndCityOptions1 = (options) => {
    if (!options && options.length) {
      return { key: 0, text: "None", value: 0 };
    }
    const parsed = options.map((el) => ({
      key: el.id,
      text: el.name,
      value: `${el.id}`,
    }));
    return [...parsed];
  };

  onChangeOfVMTypeId = (event, data) => {
    this.setState({ vmTypeId: data.value });
    console.log("cohorts type id -->", data.value);
  };

  filterAddVm = (filteraddvm) => {
    const filterdata = filteraddvm.filter((el) => el.id > 0);
    return filterdata;
  };
  filterUsers = (filterUsers) => {
    const filterdata = filterUsers.filter((el) => el.id > 0);
    return filterdata;
  };

  OnClickVMSideDetailsPage = (id) => {
    cohortid = id;
    console.log("cohorts_types--------------------", this.state.cohorts_types);
    console.log("-------------getCohortsDetailsAPI--- fun call--->");
    this.props.getCohortsDetailsAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/`,
      "GET",
      id,
      (response) => {
        console.log(
          "Get machine ################   NARESH   ###########################",
          response
        );

        this.setState({
          vmCohortDetails: response,
        });

        if (response) {
          const a = this.state.machines;
          const b = response.machines;
          console.log("DIFF--a>", a);
          console.log("DIFF-->", b);
          // A comparer used to determine if two entries are equal.
          const isSameUser = (a, b) => a.id === b.id && a.name == b.name;

          // Get items that only occur in the left array,
          // using the compareFunction to determine equality.
          const onlyInLeft = (left, right, compareFunction) =>
            left.filter(
              (leftValue) =>
                !right.some((rightValue) =>
                  compareFunction(leftValue, rightValue)
                )
            );

          const onlyInA = onlyInLeft(a, b, isSameUser);
          const onlyInB = onlyInLeft(b, a, isSameUser);

          const result = [...onlyInA, ...onlyInB];

          console.log("DIFFRENCE-----------", result);
          this.setState({ addvm: this.parseStateAndCityOptions(result) });
        }



        if (response) {
          const a = this.state.users;
          const b = response.users;
          console.log("DIFF--all-Users a>", a);
          console.log("DIFF--Users--->", b);
          // A comparer used to determine if two entries are equal.
          const isSameUser = (a, b) => a.id === b.id && a.name == b.name;

          // Get items that only occur in the left array,
          // using the compareFunction to determine equality.
          const onlyInLeft = (left, right, compareFunction) =>
            left.filter(
              (leftValue) =>
                !right.some((rightValue) =>
                  compareFunction(leftValue, rightValue)
                )
            );

          const onlyInA = onlyInLeft(a, b, isSameUser);
          const onlyInB = onlyInLeft(b, a, isSameUser);

          const result = [...onlyInA, ...onlyInB];

          console.log("DIFFRENCE---users--------", result);
          this.setState({ AddusersList: this.parseUsersOptions(result) });
        }





        //this.props.setLoading(false);
      },
      (err) => {
        this.props.setLoading(false);
        toastr.error("ERROR", err);
        console.log(err);
      }
    );

    console.log(
      "~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~",
      this.state.vmCohortDetails
    );

    console.log("NARESH SIR KE JAY HO ", this.state.machines);
    console.log("17.09.2022", this.state.vmCohortDetails);

    return 1;
  };
 
  UpadateBaseDetails = (vmid) => {
    if (!this.state.cohort_name || this.state.cohort_name.length < 3) {
      this.setState({ loading: false });
      return toastr.warning("Invalid", "Vending machine name is too small");
    }
    if (!this.state.cohortTypeId) {
      this.setState({ loading: false });
      return toastr.warning("Invalid", "Slected Cohorts Type");
    }

    if (!this.state.area_name || this.state.area_name.length < 3) {
      this.setState({ loading: false });
      return toastr.warning("Invalid", "Area is too small");
    }
    if (!this.state.description || this.state.description.length < 3) {
      this.setState({ loading: false });
      return toastr.warning("Invalid", "Description is too small");
    }
    if (!this.state.lat) {
      this.setState({ loading: false });
      return toastr.warning("Invalid", "Latitude is required");
    }
    if (!this.state.lng) {
      this.setState({ loading: false });
      return toastr.warning("Invalid", "Longtitude is required");
    }
    console.log("UpadateBaseDetails-----", vmid);
    this.props.PostcohortsbasicDataFromPartnerAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/${vmid}`,
      "PATCH",
      {
        name: this.state.cohort_name,
        areaName: this.state.area_name,
        description: this.state.description,
        lat: this.state.lat,
        lng: this.state.lng,
        cohortTypeId: this.state.cohortTypeId,
      },
      (response) => {
        console.log("api hit");
      },
      (err) => {
        console.log(err);
      }
    );

    setTimeout(
      function() {
        this.OnClickVMSideDetailsPage(cohortid);
        this.fetchagin();
        this.setState({
          modal: false,
          openbasicvmmodal: false,
        });
      }.bind(this),
      100
    );
  };
  fetchagin = () => {
    this.props.getCohortListAPI(
      "/dashboard/api/v2/admin/vendingmachines/vm-cohorts",
      "GET",
      undefined,
      (response) => {
        this.setState({
          vmCohortList: response.list,
          totalPages: response.total_count,
          loading: false,
        });
      },
      (err) => {
        console.log(err);
        toastr.error(
          "Failed",
          "Unable to fetch vending machine cohort listing"
        );
        this.setState({ loading: false });
      }
    );
  };

  AddVMfun = (vmid) => {

    console.log("UpadateBaseDetails-----", vmid);
    this.props.PostcohortsbasicDataFromPartnerAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/${vmid}/machines`,
      "POST",
      this.state.cohortvalue.map((data) => parseInt(data)),
      (response) => {
        console.log("api hit");
        console.log();
        if (response.status == "failure") {
          console.log(
            "EEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE"
          );
        }
      },
      (err) => {
        console.log(err);
      }
    );
    setTimeout(
      function() {
        this.OnClickVMSideDetailsPage(cohortid);
        this.fetchagin();
        this.setState({
          modal: false,
          openaddvmmodal: false,
        });
      }.bind(this),
      100
    );


  };

  AddUsersfun = (vmid) => {
    console.log("UpadateBaseDetails-----", vmid);
    this.props.PostcohortsbasicDataFromPartnerAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/${vmid}/users`,
      "POST",
      this.state.cohortvalue1.map((data) => parseInt(data)),
      (response) => {
        console.log("api hit");
        console.log();
        if (response.status == "failure") {
        }
      },
      (err) => {
        console.log(err);
      }
    );
    setTimeout(
      function() {
        this.OnClickVMSideDetailsPage(cohortid);
        this.fetchagin();
        this.setState({
          modal: false,
          openaddUsersmodal: false,
        });
      }.bind(this),
      100
    );
  };

  closebasicvmmodelFun = () => {
    console.log("Model close Basic");
    this.setState({ openbasicvmmodal: false });
  };
  openbasicvmmodalFun = () => {
    console.log("Model Open Basic ");
    this.closemodel();
    this.setState({
      openbasicvmmodal: true,
    });
  };
   openremoveVmmodalFun=()=>{
    console.log("Model openremoveVmmodalFun Open");
 

    this.setState({
      modal:false,
removevmmodal:true,
 })
  }

 closeremoveVmmodalFun=()=>{
    
    console.log("Model Open");
    this.setState({
      modal:true,
removevmmodal:false,
 })
  }
    
openAddusersmodalFun=()=>{
    console.log("Model Open");
   
    this.setState({
    modal:false,
    openaddUsersmodal:true
     
    })
  }
  closeAddusersmodalFun=()=>{
    
    console.log("Model Open");
    this.setState({
      modal:true,
    openaddUsersmodal:false
     
    })
  } 
  openmodel = () => {
    console.log("Model Open");

    this.setState({ modal: true });
  };

  closemodel = () => {
    console.log("Model Close ");
    this.setState({ modal: false });
  };

  openremoveusersmodalFun=()=>{
  
     console.log("Model Open");
 
    this.setState({
      modal:false,
      removeusersmodal:true})
  }

  closeremoveusersmodalFun=()=>{
    
    console.log("Model Open");
    this.setState({
      modal:true,
      removeusersmodal:false})
  }
  closeaddvmmodelFun = () => {
    console.log("Model close closeaddvmmodelFun");
    this.setState({
      openaddvmmodal: false,
      modal: true,
    });
  };
  openaddvmmodalFun = () => {
    console.log("Model Open openaddvmmodalFun");

    this.setState({
      openaddvmmodal: true,
      modal: false,
    });
  };

  removeUsersCohorts = (userId, cohortId) => {
    if (!confirm(`Are you sure you want to delete "${userId}"`)) {
      return;
    }
    // this.props.setLoading(true);
    this.props.PostcohortsbasicDataFromPartnerAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/${cohortId}/users/${userId}`,
      "DELETE",
      (response) => {
        console.log("true");

        toastr.success("Successful", "Deleted the user");
        this.props.setLoading(false);
        this.loadUserData(cohortId);
      },
      (err) => {
        this.props.setLoading(false);
        toastr.success("Successful", "Deleted the user");
       /*  toastr.error("Failed", "Delete user operation failed"); */
        this.loadUserData(cohortId);
      }
    );
  };
  onChangeOfCohortsTypeId = (e, data) => {
    this.setState({ cohortTypeId: data.value });
    console.log("updated cohort id -->", this.state.cohortTypeId);
  };
  onChangeOfVMCohort = (event, { searchQuery, value }, data) => {
    console.log("cohort id--------->", data);
    const values = String(value).split("-");
    const stateId = values[0];
    console.log("cohort id--------->", value);
    console.log("Cohort id----->:", this.state.addvm);
    const state = values[1];
    this.setState({
      cohortvalue: value,
      searchCohortQuery: searchQuery,
    });
  };
  onSearchInputChange = (e,data) => {
    
    

    const searchName = e.target.value;
    this.setState({
      searchName,
      
    });
   
  };


  onChangeSelectFilterType=(e,data)=>{
    this.setState({
     
      filterType:data.value

    });

    console.log("filterType----",this.state.filterType)

  }
  onChangeOfdescription = (e) => {
    this.setState({ description: e.target.value });
    console.log("onChangeOfdescription-------------", this.state.description);
  };
  onChangeOfAddUsersCohort = (event, { searchQuery, value }, data) => {
    console.log("cohort id--------->", data);
    const values = String(value).split("-");
    const stateId = values[0];
    console.log("cohort id--------->", value);
    console.log("Cohort id----->:", this.state.addvm1);
    const state = values[1];
    this.setState({
      cohortvalue1: value,
      searchCohortQuery1: searchQuery,
    });
  };
  handleCreateCohorts = () => {
    console.log("")
    return this.props.history.push("/vendingmachines/cohorts/new");
  };
  handleSearchChange = (e, { searchQuery }) => {
    this.setState({ searchCohortQuery: searchQuery });
    /*  console.log("search", this.searchQuery); */
  };
  handleSearchAddUserCohort = (e, { searchQuery }) => {
    this.setState({ searchCohortQuery: searchCohortQuery1 });
    /*  console.log("search", this.searchQuery); */
  };
  onPageChange = () => {};

  render() {
    const userData = this.props.userList && this.props.userList;
    console.log("17.09.2022", this.state.vmCohortDetails);
    const {searchName,searchId}= this.state;
    const cohortslistData = this.state.vmCohortList && this.state.vmCohortList && this.state.vmCohortList; 

    const filteredCohortsList =
    cohortslistData && cohortslistData.filter(
      vmlist => {

       
        if(!searchName && !searchId) 
        
        {return true; 
        
        }
      

        if(this.state.filterType=="NAME") {
        if(searchName && vmlist.name.toLowerCase().indexOf(searchName) !== -1 )
        
        
        {
          
          console.log("RETRUN ")
          return true
        
        
        };
      }



    if(this.state.filterType=="ID") 
    {
      if(searchName && String(vmlist.id).toLowerCase().startsWith(searchName) )
      
      
      {
        
        
        return true
      
      
      };
   }
        
        
       
      }
         
    );

    return (
      <VMCohortListing
        loading={this.state.loading}
        vmCohortList={filteredCohortsList}
        totalPages={this.state.totalPages}
        activePage={this.state.activePage}
        onPageChange={this.onPageChange}
        limit={this.state.limit}
        totalCount={this.state.totalPages}
        OnClickVMSideDetailsPage={this.OnClickVMSideDetailsPage}
        vmCohortDetails={this.state.vmCohortDetails}
        cohorts_types={this.state.cohorts_types}
        onChangeOfVMTypeId={this.onChangeOfVMTypeId}
        UpadateBaseDetails={this.UpadateBaseDetails}
        onChangeOfVMCohort={this.onChangeOfVMCohort}
        onChangeOfAddUsersCohort={this.onChangeOfAddUsersCohort}
        handleSearchChange={this.handleSearchChange}
        cohortvalue={this.state.cohortvalue}
        handleSearchAddUserCohort={this.handleSearchAddUserCohort}
        cohortvalue1={this.state.cohortvalue1}
        addvm={this.state.addvm}
        users={this.state.users}
        AddVMfun={this.AddVMfun}
        AddUsersfun={this.AddUsersfun}
        removeVmCohorts={this.removeVmCohorts}
        removeUsersCohorts={this.removeUsersCohorts}
        getCohortsDetailsAPI={this.props.getCohortsDetailsAPI}
        onChangeOfName={this.onChangeOfName}
        onChangeOfAreaName={this.onChangeOfAreaName}
        cohort_name={this.state.cohort_name}
        onChangeOfLng={this.onChangeOfLng}
        onChangeOfLat={this.onChangeOfLat}
        area_name={this.state.area_name}
        lat={this.state.lat}
        lng={this.state.lng}
        onChangeOfCohortsTypeId={this.onChangeOfCohortsTypeId}
        handleUpdateCohorts={this.handleUpdateCohorts}
        onChangeOfdescription={this.onChangeOfdescription}
        description={this.state.description}
        onClickOfDelete={this.onClickOfDelete}
        AddusersList={this.state.AddusersList}
        openbasicvmmodal={this.state.openbasicvmmodal}
        openbasicvmmodalFun={this.openbasicvmmodalFun}
        closebasicvmmodelFun={this.closebasicvmmodelFun}
        modal={this.state.modal}
        openmodel={this.openmodel}
        closemodel={this.closemodel}
        openaddvmmodal={this.state.openaddvmmodal}
        closeaddvmmodelFun={this.closeaddvmmodelFun}
        openaddvmmodalFun={this.openaddvmmodalFun}
        removevmmodal={this.state.removevmmodal}
        openremoveVmmodalFun={this.openremoveVmmodalFun}
        closeremoveVmmodalFun={this.closeremoveVmmodalFun}
        openaddUsersmodal={this.state.openaddUsersmodal}
        openAddusersmodalFun={this.openAddusersmodalFun}
        closeAddusersmodalFun={this.closeAddusersmodalFun}
        removeusersmodal={this.state.removeusersmodal}
        openremoveusersmodalFun={this.openremoveusersmodalFun}
        closeremoveusersmodalFun={this.closeremoveusersmodalFun}
        handleCreateCohorts={this.handleCreateCohorts}
        onSearchInputChange={this.onSearchInputChange}
        onChangeSelectFilterType={this.onChangeSelectFilterType}
      />
    );
  }
}

function mapStateToProps({ userList }) {
  console.log("mapStateProps---------------->", userList);
  return {
    userList,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    getDataFromAPI,
    getCohortListAPI,
    getCohortsDetailsAPI,
    getCohortSeedDataAPI,
    getDataFromPartnerAPI,
    PostcohortsbasicDataFromPartnerAPI,
    setLoading,
    saveData,
    setActivePage,
  })(VMCohortListingContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/VMCohortList/container.jsx